import React from 'react'

const Service = (props = {}) => (
  <svg width={24} height={24} {...props} xmlns="http://www.w3.org/2000/svg">
    <path d="M18.36 9l.6 3H5.04l.6-3h12.72M20 4H4v2h16V4zm0 3H4l-1 5v2h1v6h10v-6h4v6h2v-6h1v-2l-1-5zM6 18v-4h6v4H6z" />
  </svg>
)

export default Service
